/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySpaceUpdate
 */
export interface CompanySpaceUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceUpdate
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    user_content_creation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    user_content_activation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    domain_check?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanySpaceUpdate
     */
    allowed_domains?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    domain_hard_check?: boolean;
    /**
     * 
     * @type {object}
     * @memberof CompanySpaceUpdate
     */
    mandatory_params_hash?: object;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    email_check?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    email_hard_check?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    password_check?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    user_allowed_to_add_department?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    user_allowed_to_add_job_title?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    auto_content_upgrade?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    user_limit_enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    multiple_workplaces_enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanySpaceUpdate
     */
    workplace_tree_enabled?: boolean;
}

/**
 * Check if a given object implements the CompanySpaceUpdate interface.
 */
export function instanceOfCompanySpaceUpdate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanySpaceUpdateFromJSON(json: any): CompanySpaceUpdate {
    return CompanySpaceUpdateFromJSONTyped(json, false);
}

export function CompanySpaceUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySpaceUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'user_content_creation': !exists(json, 'user_content_creation') ? undefined : json['user_content_creation'],
        'user_content_activation': !exists(json, 'user_content_activation') ? undefined : json['user_content_activation'],
        'domain_check': !exists(json, 'domain_check') ? undefined : json['domain_check'],
        'allowed_domains': !exists(json, 'allowed_domains') ? undefined : json['allowed_domains'],
        'domain_hard_check': !exists(json, 'domain_hard_check') ? undefined : json['domain_hard_check'],
        'mandatory_params_hash': !exists(json, 'mandatory_params_hash') ? undefined : json['mandatory_params_hash'],
        'email_check': !exists(json, 'email_check') ? undefined : json['email_check'],
        'email_hard_check': !exists(json, 'email_hard_check') ? undefined : json['email_hard_check'],
        'password_check': !exists(json, 'password_check') ? undefined : json['password_check'],
        'user_allowed_to_add_department': !exists(json, 'user_allowed_to_add_department') ? undefined : json['user_allowed_to_add_department'],
        'user_allowed_to_add_job_title': !exists(json, 'user_allowed_to_add_job_title') ? undefined : json['user_allowed_to_add_job_title'],
        'auto_content_upgrade': !exists(json, 'auto_content_upgrade') ? undefined : json['auto_content_upgrade'],
        'user_limit_enabled': !exists(json, 'user_limit_enabled') ? undefined : json['user_limit_enabled'],
        'multiple_workplaces_enabled': !exists(json, 'multiple_workplaces_enabled') ? undefined : json['multiple_workplaces_enabled'],
        'workplace_tree_enabled': !exists(json, 'workplace_tree_enabled') ? undefined : json['workplace_tree_enabled'],
    };
}

export function CompanySpaceUpdateToJSON(value?: CompanySpaceUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'language': value.language,
        'user_content_creation': value.user_content_creation,
        'user_content_activation': value.user_content_activation,
        'domain_check': value.domain_check,
        'allowed_domains': value.allowed_domains,
        'domain_hard_check': value.domain_hard_check,
        'mandatory_params_hash': value.mandatory_params_hash,
        'email_check': value.email_check,
        'email_hard_check': value.email_hard_check,
        'password_check': value.password_check,
        'user_allowed_to_add_department': value.user_allowed_to_add_department,
        'user_allowed_to_add_job_title': value.user_allowed_to_add_job_title,
        'auto_content_upgrade': value.auto_content_upgrade,
        'user_limit_enabled': value.user_limit_enabled,
        'multiple_workplaces_enabled': value.multiple_workplaces_enabled,
        'workplace_tree_enabled': value.workplace_tree_enabled,
    };
}

